"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransitionHelper = exports.SizeClasses = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@headlessui/react");
const utils_1 = require("../utils");
var SizeClasses;
(function (SizeClasses) {
    SizeClasses["default"] = "default";
    SizeClasses["medium"] = "medium";
    SizeClasses["large"] = "large";
    SizeClasses["full"] = "full";
    SizeClasses["auto"] = "auto";
})(SizeClasses = exports.SizeClasses || (exports.SizeClasses = {}));
exports.TransitionHelper = (0, react_1.forwardRef)((props, ref) => {
    const baseClasses = 'absolute z-20 mt-2';
    const layerClasses = props.raw ? '' : 'rounded-content shadow-popover py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none';
    const origin = props.origin || 'right';
    const originClasses = {
        right: 'end-0 origin-top-end',
        left: 'origin-top-start start-0',
        top: 'origin-top',
        default: '',
    };
    const sizeClasses = {
        default: 'w-48',
        medium: 'w-64',
        large: 'w-72 sm:w-80',
        full: 'w-full',
        auto: 'w-auto',
    };
    const size = props.size || 'default';
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(react_2.Transition, { show: props.show, ref: ref, style: props.style, className: (0, utils_1.classNames)(baseClasses, layerClasses, sizeClasses[size], originClasses[origin], props.className), enter: "transition ease-out duration-200", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95" }, props.children)));
});
//# sourceMappingURL=index.js.map